export default "__VITE_ASSET__CKkAdR9t__"